import {
  type EditorPlugin,
  type TransformPlugin,
} from '@aha-app/aha-editor-v2';

export function rewriteKBURL(href: string): string {
  if (!href) href = '';

  const data = window.knowledgeBasePageData;
  if (!data) return href;

  // See if the link looks like a document.
  const referenceMatch = href.match(/\/pages\/([^/?#]+)/);
  if (!referenceMatch) {
    return href;
  }

  const reference = referenceMatch[1];
  const pageId = [data.references[reference], reference].find(
    pageId => data.pages[pageId]
  );
  if (!pageId) return href;
  const page = data.pages[pageId];
  if (!page) return href;

  let hash = '';
  try {
    hash = new URL(href).hash;
  } catch (e) {
    console.error(e);
  }

  const kbRoot = document
    .querySelector('meta[name=knowledge-base-path]')
    ?.getAttribute('content');

  return `${kbRoot}/${page.path}~${pageId}${hash}`;
}

export default function KnowledgeBaseLinkRewriterPlugin(): EditorPlugin {
  return {
    name: 'Knowledge Base link rewriter',
    transformer: {
      type: 'link',
      transform: element => {
        const { link_href: href } = element;
        if (!href) return element;

        const newHref = rewriteKBURL(href);

        if (newHref === href) {
          return element;
        }

        return {
          ...element,
          link_href: newHref,
          link_target: '_self',
        };
      },
    } as TransformPlugin<'link'>,
  };
}
